/** @jsx h */
import { h } from 'preact'

const ArrowIcon = ({
  style = {},
  fill = '#000',
  stroke = '#000',
  width = '8',
  height = '4.969',
  className = '',
  viewBox = '0 0 8 4.969'
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox}
    xmlns='http://www.w3.org/2000/svg'
    className={`rcc_c_arrow-icon ${className}`}
  >
    <g transform='translate(8) rotate(90)'>
      <path
        d='M291.158,103.6l-.667-.716,3.533-3.283-3.533-3.284.667-.716,4.3,4Z'
        transform='translate(-290.491 -95.597)'
      />
    </g>
  </svg>
)

export default ArrowIcon
